import "./ColorImg.less"

type ColorImgProps = {
    src: string;
    color?: string;
    style?: React.CSSProperties;
    onClick?: (e:any) => void;
    className?: string;
};

const foo = () => {};

export const ColorImg = (props: ColorImgProps): React.ReactElement => {
    return <div className={`${props.className || ""} color-img`} style={{...props.style, "--bg-color": props.color || "unset", "--url": `url(${props.src})`} as React.CSSProperties}
        onClick={props.onClick || foo}></div>;
};